import React, { useEffect, useState } from "react";
import MDBox from "components/MDBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Tree from "react-d3-tree";
import { useSelector } from "react-redux";
import axios from "axios";
import SignIn from "layouts/authentication/sign-in";
import { useNavigate } from "react-router-dom";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import FamilyTree from "layouts/FamilyTree";

const Treeview = () => {
  const [treeData, settreedata] = useState([]);
  const [dataTree, setdataTree] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [familyTreeOpen, setFamilyTreeOpen] = useState(false);
  const [activeFamilyTreeUserId, setActiveFamilyTreeUserId] = useState(null);
  const [activeFamilyTreeUserName, setActiveFamilyTreeUserName] = useState(null);

  // Get logged-in user id from Redux (matches other selectors in the app)
  const user_id = useSelector((state) =>
    state.session.setUserId ? state.session.setUserId.value : null
  );
  console.log(user_id);
  const sessionId = useSelector((state) => state.session.sessionId || null);
  const navigate = useNavigate();

  const getTreeData = async () => {
    // debugger;

    const apiUrl = "https://seltentechnologiesdemo.com/moona-backend/ReferralTreeview.php";
    const payload = {
      session_id: sessionId,
      parent_id: user_id,
    };

    try {
      const response = await axios({
        method: "get",
        url: apiUrl,
        params: payload,
      });
      console.log(response, "test");
      settreedata(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const dummyTreeData = [
    {
      name: "saran",
      user_id: "1",
      father: "Rajendran",
      mother: "Lakshmi",
      wife: "Deepa",
      son: "Arjun",
    },
    {
      name: "karthick",
      user_id: "2",
      father: "Gopal",
      mother: "Meenakshi",
      wife: "Meena",
      daughter: "Nila",
    },
    {
      name: "karthi",
      user_id: "3",
      father: "Subramanian",
      mother: "Revathi",
      wife: "Swathi",
    },
    {
      name: "ragu",
      user_id: "4",
      father: "Natarajan",
      mother: "Janaki",
      wife: "Anitha",
      son: "Pranav",
    },
    {
      name: "aravind",
      user_id: "5",
      father: "Kumar",
      mother: "Radha",
      wife: "Aishwarya",
      daughter: "Shruthi",
    },
    {
      name: "Aravindh",
      user_id: "5",
      father: "Kumar",
      mother: "Radha",
      wife: "Aishwarya",
      daughter: "Shruthi",
    },
    {
      name: "raga",
      user_id: "6",
      father: "Sundar",
      mother: "Bhavani",
      wife: "Pooja",
    },
    {
      name: "Shakthi",
      user_id: "7",
      father: "Balakrishnan",
      mother: "Uma",
      sister: "Harini",
    },
    {
      name: "Vicknesh",
      user_id: "8",
      father: "Dinesh",
      mother: "Sujatha",
      wife: "Bhavya",
      son: "Sanjay",
    },
    {
      name: "Chathrian",
      user_id: "9",
      father: "Muthukumar",
      mother: "Geetha",
      wife: "Latha",
      daughter: "Diya",
    },
    {
      name: "Guna",
      user_id: "10",
      father: "Sivasankar",
      mother: "Anjali",
      wife: "Ramya",
      brother: "Surya",
    },
    {
      name: "veera",
      user_id: "11",
      father: "Ravi",
      mother: "Ranjani",
      brother: "Raga",
    },
    {
      name: "surya",
      user_id: "12",
      father: "Mahesh",
      mother: "Sharanya",
      sister: "Sneha",
    },
    {
      name: "shri",
      user_id: "13",
      father: "Krishnan",
      mother: "Sangeetha",
      husband: "Arun",
      sister: "Sneha",
      brother: "Raga",
      daughter: "Ishita",
      son: "Kavin",
    },
  ];

  const handleNodeClick = (nodeData) => {
    const name = nodeData.name;
    const userId = nodeData.user_id;
    console.log("node id", userId);

    if (userId && name) {
      setActiveFamilyTreeUserId(userId);
      setActiveFamilyTreeUserName(name);
      setFamilyTreeOpen(true);
    } else {
      console.log("User not found in data.");
    }
  };
    const CloseFamilyTree = () => {
    setFamilyTreeOpen(false);
    setActiveFamilyTreeUserId(null);
  };

  useEffect(() => {
    // Only fetch when we have both session and user id to avoid "Parent ID not provided." errors
    if (sessionId && user_id) {
      getTreeData();
    }
  }, [sessionId, user_id]);
  useEffect(() => {
    if (!sessionId) {
      navigate("/authentication/sign-in"); // Redirect to login if sessionId is null
    }
  }, [sessionId, navigate]);

  return (
    <>
      {!sessionId ? (
        <SignIn />
      ) : (
        <DashboardLayout>
          <DashboardNavbar />
          {/* <MDBox py={3}> */}
          {/* <MDBox py={3} className="fixed inset-0 z-10 w-screen overflow-y-auto"> */}
          <div id="treeWrapper" style={{ width: "100%", height: "100vh" }} className="flex ">
            {treeData.length > 0 ? (
              <Tree
                data={treeData}
                onNodeClick={(node) => handleNodeClick(node.data)}
                // Pass the API response directly to the Tree component
                pathFunc="step"
                orientation="vertical"
                nodeSvgShape={{
                  shape: "rect",
                }}
                rootNodeClassName="node__root"
                branchNodeClassName="node__branch"
                leafNodeClassName="node__leaf"
              />
            ) : (
              <p>Loading tree data...</p> // Loading message while data is being fetched
            )}
          </div>
          {/* </MDBox> */}

          <MDBox></MDBox>
          {/* </MDBox> */}
        </DashboardLayout>
      )}

      <Dialog
        open={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        PaperProps={{
          style: {
            width: "500px",
            maxWidth: "60vw",
            minheight: "200px",
            maxHeight: "60vh",
          },
        }}
      >
        <DialogTitle sx={{ textAlign: "center", fontWeight: "bold" }}>
          {selectedUser
            ? selectedUser.name.charAt(0).toUpperCase() + selectedUser.name.slice(1)
            : {}}{" "}
          Family Details
        </DialogTitle>
        <DialogContent
          dividers
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center", // Center horizontally
          }}
        >
          {selectedUser ? (
            <div>
              {selectedUser.father && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Father</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.father}</Box>
                </Box>
              )}
              {selectedUser.mother && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Mother</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.mother}</Box>
                </Box>
              )}
              {selectedUser.wife && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Wife</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.wife}</Box>
                </Box>
              )}
              {selectedUser.husband && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Husband</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.husband}</Box>
                </Box>
              )}
              {selectedUser.son && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Son</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.son}</Box>
                </Box>
              )}
              {selectedUser.daughter && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Daughter</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.daughter}</Box>
                </Box>
              )}
              {selectedUser.brother && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Brother</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.brother}</Box>
                </Box>
              )}
              {selectedUser.sister && (
                <Box display="flex" justifyContent="flex-start" mb={1}>
                  <Box width="120px">
                    <strong>Sister</strong>
                  </Box>
                  <Box>:&nbsp;&nbsp;&nbsp; {selectedUser.sister}</Box>
                </Box>
              )}
            </div>
          ) : (
            <Typography>No user data found</Typography>
          )}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setIsModalOpen(false)}>Close</Button>
        </DialogActions>
      </Dialog>
      <Dialog open={familyTreeOpen} onClose={CloseFamilyTree} maxWidth="md" fullWidth>
              <DialogTitle textAlign="center" >{activeFamilyTreeUserName}'s Family Tree</DialogTitle>
              <DialogContent dividers>
                {activeFamilyTreeUserId && (
                  <FamilyTree
                    userId={activeFamilyTreeUserId}
                    userName={activeFamilyTreeUserName}
                    onClose={CloseFamilyTree}
                  />
                )}
              </DialogContent>
              <DialogActions>
                <Button onClick={CloseFamilyTree} color="primary">
                  Close
                </Button>
              </DialogActions>
            </Dialog>
    </>
  );
};

export default Treeview;
